import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const statisticApi = createApi({
  reducerPath: "statisticApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Statistic", "StationsStatistic", "StationStatistic"],
  endpoints: (builder) => ({
    getChefStatistic: builder.query({
      query: ({ subDomain, id }) => {
        return {
          url: `/statistic/chef/${id}`,
          method: "GET",
          params: { subdomain: subDomain },
        };
      },
      providesTags: ['Statistic'],
    }),
    getStationsStatistic: builder.query({
      query: ({ subDomain, dates }) => {
        if(dates.length > 1 && dates[1] !== null) {
          return {
            url:'/statistic/stations',
            method: "GET",
            params: { subdomain: subDomain, start: dates[0], end: dates[1] },
          }
        }
        return {
          url: '/statistic/stations/',
          method: "GET",
          params: { subdomain: subDomain, date: dates[0] },
        }
      },
      providesTags: ["StationsStatistic"]
    }),
    getStationStatistic: builder.query({
      query: ({subdomain, dates, slot, stationId}) => {
        if(dates.length > 1 && dates[1] !== null) {
          if(slot === 'all-slots') {
            return {
              url: `/statistic/${stationId}`,
              method: "GET",
              params: {subdomain, start: dates[0], end: dates[1], time_slots: true },
            }
          } else {
            return {
              url: `/statistic/${stationId}`,
              method: "GET",
              params: {subdomain, start: dates[0], end: dates[1], time_slot_id: slot},
            }
          }
        } else {
          if(slot === 'all-slots') {
            return {
              url: `/statistic/${stationId}`,
              method: "GET",
              params: {subdomain, date: dates[0], time_slots: true },
            }
          } else {
            return {
              url: `/statistic/${stationId}`,
              method: "GET",
              params: {subdomain, date: dates[0], time_slot_id: slot},
            }
          }
        }
      },
      providesTags: ["StationStatistic"]
    })
  }),
});

export const {
  useLazyGetChefStatisticQuery,
  useGetChefStatisticQuery,
  useGetStationsStatisticQuery,
  useGetStationStatisticQuery
} = statisticApi;
